import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import { Button } from '@monorepo/shared/componentsV2/Button';
import { FieldTypePreviewFactory } from '@monorepo/shared/componentsV2/fieldDataType/FieldTypePreview/FieldTypePreviewFactory';
import {
  Content,
  Page,
  Title,
} from '@monorepo/shared/componentsV2/fullPageWizard/styled/fullPageWizard';
import { Loading } from '@monorepo/shared/componentsV2/Loading';
import { Tooltip } from '@monorepo/shared/componentsV2/Tooltip';
import { useLogFormulaFields } from '@monorepo/shared/hooks/logs/useLogFields';
import { useDisableSubnav } from '@monorepo/shared/hooks/subnav/useDisableSubnav';
import { useFeatureFlags } from 'mapistry-shared/api';
import React from 'react';
import { useParams } from 'react-router-dom';
import { useLogFieldCommonState } from '../../hooks/useLogFieldCommonState';
import { EditLogFormulaFieldModal } from '../EditLogFormulaFieldModal';
import {
  EditLogFormulasEmptyState,
  LEGACY_LOG_FORMULAS_DISABLED_EXPLANATION,
} from './EditLogFormulasEmptyState';
import { EditLogHeader, WizardStep } from './EditLogHeader';
import { Description, FieldList } from './styled';

export function EditLogFormulas() {
  useDisableSubnav();

  const { areLegacyLogFormulasEnabled } = useFeatureFlags();
  const { logId, organizationId } = useParams();
  const { logFields, isLoading } = useLogFormulaFields({
    logId,
    organizationId,
  });
  const { closeModal, field, getMenu, open, openModal } =
    useLogFieldCommonState({
      fieldType: 'formula',
      logId,
      organizationId,
    });

  if (isLoading) {
    return <Loading />;
  }

  return (
    <Page>
      <EditLogFormulaFieldModal
        field={field}
        open={open}
        onClose={closeModal}
      />
      <EditLogHeader wizardStep={WizardStep.FORMULAS} />
      <Content>
        {logFields?.length ? (
          <>
            <Title id="formula-fields">Formula Fields</Title>
            <Description>
              Formula fields allow you to perform basic operations between two
              or more Log fields.
            </Description>
            <FieldList aria-labelledby="formula-fields">
              {logFields?.map((formulaField) => (
                <FieldTypePreviewFactory
                  actionMenuOptions={getMenu(formulaField)}
                  field={formulaField}
                  key={formulaField.name}
                />
              ))}
            </FieldList>
            <Tooltip
              title={
                areLegacyLogFormulasEnabled
                  ? ''
                  : LEGACY_LOG_FORMULAS_DISABLED_EXPLANATION
              }
            >
              <span>
                <Button
                  color="primary"
                  onClick={() => openModal()}
                  disabled={!areLegacyLogFormulasEnabled}
                  focusableWhenDisabled={!areLegacyLogFormulasEnabled}
                >
                  <AddCircleOutlineIcon />
                  Add a formula
                </Button>
              </span>
            </Tooltip>
          </>
        ) : (
          <EditLogFormulasEmptyState openModal={openModal} />
        )}
      </Content>
    </Page>
  );
}
